import bg1 from '../assets/images/bg/1.jpg'
import bg2 from '../assets/images/bg/2.jpg'
import bg3 from '../assets/images/bg/3.jpg'
import bg4 from '../assets/images/bg/4.jpg'
import bg5 from '../assets/images/bg/5.jpg'
import bg6 from '../assets/images/bg/6.jpg'
import bg7 from '../assets/images/bg/7.jpg'
import bg8 from '../assets/images/bg/8.jpg'
import bg9 from '../assets/images/bg/9.jpg'

export const BACKGROUND_OPTIONS = [
  { id: 'none', label: 'No background', thumbnail: '', image: '' },
  { id: 'bg-1', label: 'Background 1', thumbnail: bg1, image: bg1 },
  { id: 'bg-2', label: 'Background 2', thumbnail: bg2, image: bg2 },
  { id: 'bg-3', label: 'Background 3', thumbnail: bg3, image: bg3 },
  { id: 'bg-4', label: 'Background 4', thumbnail: bg4, image: bg4 },
  { id: 'bg-5', label: 'Background 5', thumbnail: bg5, image: bg5 },
  { id: 'bg-6', label: 'Background 6', thumbnail: bg6, image: bg6 },
  { id: 'bg-7', label: 'Background 7', thumbnail: bg7, image: bg7 },
  { id: 'bg-8', label: 'Background 8', thumbnail: bg8, image: bg8 },
  { id: 'bg-9', label: 'Background 9', thumbnail: bg9, image: bg9 },
]

export const BACKGROUND_IDS = BACKGROUND_OPTIONS.map((background) => background.id)

export function findBackgroundOption(id = 'none') {
  return BACKGROUND_OPTIONS.find((background) => background.id === id) || BACKGROUND_OPTIONS[0]
}
